import * as React from 'react';
import { Container } from '../../components/Container';
import { SIZE_16, SIZE_4 } from '../../constants/sizes';
import { SeoSubtitles } from '../../components/SeoSubtitles/SeoSubtitles';
import { ArticleParagraph3 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { getIsFilterUpcomingSaleEnabled } from '../../selectors/location';
import { getSubtitle } from '../../selectors/seo';
import { getMapFullUrl } from '../../selectors/offersData';
import { getQuickLinksTabs } from '../../selectors/quickLinks';

export const Subheading = () => {
  const isInfoSection = useSelector(getIsFilterUpcomingSaleEnabled);
  const mapFullUrl = useSelector(getMapFullUrl);
  const subtitle = useSelector(getSubtitle);
  const tabs = useSelector(getQuickLinksTabs);

  const showSubtitles = React.useMemo(() => {
    return Boolean(mapFullUrl || subtitle || tabs.length > 0);
  }, [mapFullUrl, subtitle, tabs.length]);

  return (
    <>
      {showSubtitles && <SeoSubtitles subtitle={subtitle} />}
      {isInfoSection && (
        <Container margin={`${SIZE_4} 0 0 ${SIZE_16}`}>
          <ArticleParagraph3 color="text-primary-disabled">Информационный раздел</ArticleParagraph3>
        </Container>
      )}
    </>
  );
};
